/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';

import { AuthNumberDto } from './auth-numbers.dto';

export const AuthNumbersMapper = entity<AuthNumberDto>({});
